import React, {useEffect, useRef, useState} from 'react';
import {useLocation} from 'react-router';
import SupportAgentOutlinedIcon from '@mui/icons-material/SupportAgentOutlined';
import {Paper, TextareaAutosize} from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import Button from '@mui/material/Button';
import {Col, Row} from 'react-bootstrap';
import SupportIcon from '@mui/icons-material/Support';
import {useForm} from 'react-hook-form';
import Alert, {useAlert} from 'components/snacks/Alert';
import {confirmDialog} from 'primereact/confirmdialog';
import {getTicketDetail, getTicketList, postCloseTicket, postNewTicketDetail} from 'api/Api';
import Loading from 'layout/Loading';
import {BASE_URL} from 'utils/DataBase';
import {CKEditor} from '@ckeditor/ckeditor5-react';
import 'ckeditor5.css';

import {
    ClassicEditor,
    Alignment,
    AutoLink,
    Autosave,
    Bold,
    Code,
    Essentials,
    Italic,
    Link,
    Paragraph,
    Underline,
    Undo
} from 'ckeditor5';
//
//
const confirm = () => {
    confirmDialog({
        message: 'آیا از بستن تیکت مطمئن هستید؟',
        icon: 'pi pi-exclamation-triangle',
        style: {}
        // accept: () => acceptFunc(),
        // reject: () => rejectFunc()
    });
};

const TicketDetail = () => {
    const {
        formState: {errors}
    } = useForm();
    const scrollerDiv = useRef();
    const [ticketLength, setTicketLength] = useState(null);
    const [ticket, setTicket] = useState(null);
    const [file, setFile] = useState(null);
    const [fileResult, setFileResult] = useState(null);
    const [base64, setBase64] = useState(null);
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [confirmData, setConfirmData] = useState()
    const location = useLocation();

    const [showModal, setShowModal] = useState(false);
    const handleShowModal = () => {
        setShowModal(!showModal);
    };

    const alert_timeout = 10000;
    const alertStore = useAlert(alert_timeout);

    const getMessages = () => {
        setLoading(true);
        getTicketDetail(location.state.id, (isOk, data) => {
            if (isOk) {
                setTicket(data);
                setTicketLength(data.length);
                setLoading(false);
            } else {
                alertStore.AddAlert({
                    key: '400',
                    message: data,
                    severity: 'error',
                    auto_hide: true
                });
            }
        });
    };

    const newTicket = () => {
        const formData = new FormData();
        formData.append('message', message);
        formData.append('ticket_file', file);
        formData.append('t_id', location.state.id);
        if (!message) {
            alertStore.AddAlert({
                key: '400',
                message: 'پیام خالی می باشد!',
                severity: 'error',
                auto_hide: true
            });
        } else {
            setLoading(true);
            postNewTicketDetail(formData, (isOk, data) => {
                if (isOk) {
                    setLoading(false);
                    alertStore.AddAlert({
                        key: '400',
                        message: data,
                        severity: 'success',
                        auto_hide: true
                    });
                    getMessages();
                } else {
                    setLoading(false);
                    alertStore.AddAlert({
                        key: '400',
                        message: data,
                        severity: 'error',
                        auto_hide: true
                    });
                }
            });
        }
    };

    const newCloseTicket = () => {
        const formData = new FormData();
        formData.append('t_id', location.state.id);
        setLoading(true);
        postNewTicketDetail(formData, (isOk, data) => {
            if (isOk) {
                getMessages();
                handleShowModal();
            }
        });

        postCloseTicket(formData, (isOk, data) => {
            if (isOk) {
                getMessages();
                handleShowModal();
            }
        });
    };

    const [readyLayout, setReadyLayout] = useState(false);


    // getTicketList((isOk, data) => {
    //   if(isOk){
    //     setConfirmData(data)
    //   }
    // })
    // console.log(confirmData)

    // useEffect(() => {
    //   if (file) {
    //     getBase64(file)
    //       .then((result) => {
    //         file['base64'] = result;
    //         setBase64(result);
    //         setFileResult(result);
    //       })
    //       .catch((err) => {
    //         alert(err.msg);
    //       });
    //   }
    // }, [file]);

    useEffect(() => {
        getMessages();
        setReadyLayout(true);
    }, []);

    const editorConfig = {
        toolbar: {
            items: [
                'undo',
                'redo',
                '|',
                'bold',
                'italic',
                'underline',
                'code',
                '|',
                'link',
                '|',
                'alignment',
            ],
            shouldNotGroupWhenFull: false
        },
        plugins: [
            Undo,
            Alignment,
            AutoLink,
            Autosave,
            Bold,
            Code,
            Essentials,
            Italic,
            Link,
            Paragraph,
            Underline
        ],
        initialData:
            '',
        language: 'fa',
        link: {
            addTargetToExternalLinks: true,
            defaultProtocol: 'https://',
            decorators: {
                toggleDownloadable: {
                    mode: 'manual',
                    label: 'Downloadable',
                    attributes: {
                        download: 'file'
                    }
                }
            }
        },
        placeholder: 'متن ...'
    };

    return (
        <Row>
            {loading ? (
                <Loading/>
            ) : (
                <>
                    <Col lg={'8'} md={'10'} xs={'12'} className={'mx-auto'}>
                        <Paper
                            elevation={1}
                            className="card mb-lg-10 mb-5"
                            id="kt_chat_messenger"
                        >
                            <div className="card-header" id="kt_chat_messenger_header">
                                <div
                                    className={
                                        'd-flex flex-lg-row flex-column justify-content-between w-100'
                                    }
                                >
                                    <div className="card-title d-flex flex-column">
                                        <div
                                            className={
                                                'd-flex justify-content-start align-items-center pe-5 pb-7 pt-5'
                                            }
                                        >
                                            <SupportIcon color={'white'} className={'f-18'}/>
                                            <h4 className="fw-boldest text-gray-800 f-15">
                                                جزییات تیکت
                                            </h4>
                                            <Button
                                                variant="contained"
                                                // onClick={newCloseTicket}
                                                // onClick={confirm}
                                                onClick={handleShowModal}
                                                sx={{
                                                    height: '30px',
                                                    paddingRight: '15px',
                                                    paddingLeft: '15px',
                                                    marginRight: '20px'
                                                }}
                                            >
                                                بستن تیکت
                                            </Button>
                                            {/* <ConfirmDialog /> */}

                                            <div className="d-flex align-items-end gap-4">
                                                <div
                                                    className={`${
                                                        showModal ? 'modal-gig-active' : 'modal-gig-none'
                                                    }`}
                                                    onClick={handleShowModal}
                                                ></div>
                                                <div
                                                    className={`modal-gig-window ${
                                                        showModal
                                                            ? 'modal-gig-window-active'
                                                            : 'modal-gig-window-none'
                                                    }`}
                                                >
                                                    <div className="ticket-confirm">
                                                        <h3>آیا از بستن تیکت مطمئن هستید؟</h3>
                                                        <div className="d-flex">
                                                            <Button
                                                                variant="contained"
                                                                onClick={newCloseTicket}
                                                                sx={{
                                                                    height: '30px',
                                                                    paddingRight: '15px',
                                                                    paddingLeft: '15px',
                                                                    marginRight: '20px'
                                                                }}
                                                            >
                                                                آره
                                                            </Button>
                                                            <Button
                                                                variant="contained"
                                                                onClick={handleShowModal}
                                                                sx={{
                                                                    height: '30px',
                                                                    paddingRight: '15px',
                                                                    paddingLeft: '15px',
                                                                    marginRight: '20px'
                                                                }}
                                                            >
                                                                نه
                                                            </Button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="d-flex justify-content-center flex-column me-3">
                                        <div
                                            className={
                                                'd-flex justify-content-start align-items-center mb-2'
                                            }
                                        >
                                            <span className={'me-2'}>عنوان: </span>
                                            <span className="fs-4 fw-bolder text-gray-900 text-hover-primary me-1 lh-1">
                        {location.state.title}
                      </span>
                                        </div>
                                        <div className="mb-0 lh-1 mt-2">
                      <span className="badge badge-light-success me-3">
                        شماره تیکت
                      </span>
                                            <span className="fs-7 fw-bold text-muted">
                        #{location.state.id}
                      </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body" id="kt_chat_messenger_body">
                                <div
                                    ref={scrollerDiv}
                                    id={'scrollYDiv'}
                                    className="scroll-y me-n5 pe-5 h-300px h-lg-auto"
                                    style={{maxHeight: '499px'}}
                                >
                                    {ticket && ticketLength ? (
                                        ticket.map((item, index) => (
                                            <div key={index}>
                                                {item.created_by === 'user' ? (
                                                    <div className="d-flex justify-content-start mb-10">
                                                        <div className="d-flex flex-column align-items-start">
                                                            <div className="d-flex align-items-center mb-2">
                                                                <div className="symbol symbol-35px symbol-circle">
                                                                    <i className="bi bi-person f-3"/>
                                                                </div>
                                                                <div className="ms-3 d-flex flex-column">
                                  <span className="fw-bolder text-gray-900 text-hover-primary me-1">
                                    شما
                                  </span>
                                                                    <span className="text-muted fs-8 mb-1">
                                    {item.created_at}
                                  </span>
                                                                </div>
                                                            </div>
                                                            <div
                                                                className="d-flex justify-content-between align-items-center">
                                                                <div
                                                                    className="p-5 rounded bg-light-info text-dark mw-lg-400px text-start text-justify text-wrap-pre"
                                                                    data-kt-element="message-text"
                                                                    dangerouslySetInnerHTML={{__html: item.message}}
                                                                >
                                                                </div>
                                                                {item.image_file && (
                                                                    <a href={BASE_URL + item.image_file} download>
                                                                        <svg
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            width="20"
                                                                            height="20"
                                                                            fill="currentColor"
                                                                            className="bi bi-cloud-arrow-down ms-2"
                                                                            viewBox="0 0 16 16"
                                                                        >
                                                                            <path
                                                                                fillRule="evenodd"
                                                                                d="M7.646 10.854a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 9.293V5.5a.5.5 0 0 0-1 0v3.793L6.354 8.146a.5.5 0 1 0-.708.708l2 2z"
                                                                            />
                                                                            <path
                                                                                d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383zm.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z"/>
                                                                        </svg>
                                                                    </a>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className="d-flex justify-content-end mb-10">
                                                        <div className="d-flex flex-column align-items-end">
                                                            <div className="d-flex align-items-center mb-2">
                                                                <div
                                                                    className="me-3 d-flex flex-column align-items-end">
                                  <span className="fs-5 fw-bolder text-gray-900 text-hover-primary ms-1">
                                    پشتیبانی ({item.created_by})
                                  </span>
                                                                    <span className="text-muted fs-7 mb-1">
                                    {item.created_at}
                                  </span>
                                                                </div>
                                                                <div className="symbol symbol-35px symbol-circle">
                                                                    <SupportAgentOutlinedIcon
                                                                        className={'f-4'}
                                                                        style={{color: '#a1a5b7'}}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div
                                                                className="d-flex justify-content-between align-items-center">
                                                                {item.image_file && (
                                                                    <a href={BASE_URL + item.image_file} download>
                                                                        <svg
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            width="20"
                                                                            height="20"
                                                                            fill="currentColor"
                                                                            className="bi bi-cloud-arrow-down me-2"
                                                                            viewBox="0 0 16 16"
                                                                        >
                                                                            <path
                                                                                fill-rule="evenodd"
                                                                                d="M7.646 10.854a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 9.293V5.5a.5.5 0 0 0-1 0v3.793L6.354 8.146a.5.5 0 1 0-.708.708l2 2z"
                                                                            />
                                                                            <path
                                                                                d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383zm.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z"/>
                                                                        </svg>
                                                                    </a>
                                                                )}
                                                                <div
                                                                    style={{textAlign: 'justify !important'}}
                                                                    className="p-5 rounded bg-light-primary text-dark mw-lg-400px text-end text-justify text-wrap-pre"
                                                                    data-kt-element="message-text"
                                                                    dangerouslySetInnerHTML={{__html: item.message}}
                                                                >
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        ))
                                    ) : (
                                        <h3>تیکتی موجود نمی باشد.</h3>
                                    )}
                                </div>
                            </div>
                            <div className="card-footer pt-4" id="kt_chat_messenger_footer">
                                <Row className={'mt-5'}>
                                    <Col lg={'5'} md={'7'} xs={'12'} className={''}>
                                        <label className={'w-100 mb-1'}>
                                          <span className={''}>
                                            متن پیام
                                            <span className={'text-danger'}>*</span>
                                          </span>
                                        </label>
                                        {readyLayout && <CKEditor
                                            editor={ClassicEditor}
                                            config={editorConfig}
                                            onChange={(event, editor) => {
                                                const data = editor.getData();
                                                setMessage(data);
                                            }}
                                        />}
                                        <label
                                            style={{
                                                borderBottom: '2px solid #e7e4e4',
                                                cursor: 'pointer'
                                            }}
                                            className="form-control form-control-lg form-control-solid mb-3 w-100 mb-7 mt-3"
                                        >
                                            <CloudUploadIcon color={'action'}/>
                                            {file ? (
                                                <span className={'ps-4'}>{file.name}</span>
                                            ) : (
                                                <span className={'ps-4'}> انتخاب فایل </span>
                                            )}
                                            <input
                                                name={'ticket_file'}
                                                type={'file'}
                                                onChange={(e) => setFile(e.target.files[0])}
                                                accept={'image/*,.pdf'}
                                                hidden
                                            />
                                        </label>
                                        <Button
                                            color={'primary'}
                                            variant={'contained'}
                                            className={'f-09 yekan-font'}
                                            onClick={newTicket}
                                        >
                                            ثبت تیکت
                                        </Button>
                                    </Col>
                                </Row>
                            </div>
                        </Paper>
                    </Col>
                </>
            )}
            {
                <Alert
                    alerts={alertStore.alert}
                    close={alertStore.RemoveAlert}
                    timeout={alert_timeout}
                />
            }
        </Row>
    );
};

export default TicketDetail;
